import React, { useState } from "react";
import { CalendarPlus } from "lucide-react";

const CODES = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
const pad = (n) => String(n).padStart(2, "0");
const esc = (s) => s.replace(/[\\,;]/g, (m) => `\\${m}`);

// Build a .ics with 7 weekly repeating events (Sun–Sat), each with that day's task.
const buildIcs = (days, time, course) => {
  const [hh, mm] = time.split(":").map(Number);
  const now = new Date();
  const sunday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay());
  const stamp = now.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const events = days.map(([d, title, txt], i) => {
    const s = new Date(sunday.getFullYear(), sunday.getMonth(), sunday.getDate() + i, hh, mm);
    const e = new Date(s.getTime() + (i === 6 ? 10 : 30) * 60000);
    const f = (x) => `${x.getFullYear()}${pad(x.getMonth() + 1)}${pad(x.getDate())}T${pad(x.getHours())}${pad(x.getMinutes())}00`;
    return ["BEGIN:VEVENT", `UID:jthub-${CODES[i]}-${course.toLowerCase().replace(/[^a-z]+/g, "-")}@thejthub.com`, `DTSTAMP:${stamp}`, `DTSTART:${f(s)}`, `DTEND:${f(e)}`,
      `RRULE:FREQ=WEEKLY;BYDAY=${CODES[i]}`, `SUMMARY:${esc(`The JT Hub · ${title}`)}`, `DESCRIPTION:${esc(`${course}: ${txt}`)}`,
      "BEGIN:VALARM", "TRIGGER:-PT10M", "ACTION:DISPLAY", `DESCRIPTION:${esc(title)}`, "END:VALARM", "END:VEVENT"].join("\r\n");
  });
  return ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//The JT Hub//Practice schedule//EN", "CALSCALE:GREGORIAN", ...events, "END:VCALENDAR"]
    .join("\r\n").split("\r\n").map(fold).join("\r\n");
};

// RFC 5545 line folding at 75 characters.
const fold = (line) => line.length <= 75 ? line : line.match(/.{1,74}/g).join("\r\n ");

export const CalendarExport = ({ days, course }) => {
  const [time, setTime] = useState("18:00");
  const download = () => {
    const blob = new Blob([buildIcs(days, time, course)], { type: "text/calendar;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "jt-hub-practice-schedule.ics";
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  };
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2 rounded-xl border border-dashed border-border p-3" data-testid="calendar-export">
      <CalendarPlus size={16} className="text-primary" />
      <label htmlFor="cal-time" className="text-sm">Practice each day at</label>
      <input id="cal-time" type="time" value={time} onChange={(e) => setTime(e.target.value || "18:00")} data-testid="calendar-export-time"
        className="rounded-lg border border-border bg-background px-2 py-1 text-sm" />
      <button onClick={download} data-testid="calendar-export-btn"
        className="rounded-full bg-primary px-4 py-1.5 text-sm font-semibold text-primary-foreground hover:bg-primary/90">Add to my calendar</button>
      <span className="text-xs text-muted-foreground">Works with iPhone, Google and Outlook calendars. Repeats every week.</span>
    </div>
  );
};
